module.exports = __webpack_public_path__ + "img/simbol-erd.5b7e769e.png";